import React, { useState, useEffect } from 'react';
import { functions } from '../../services/firebase';
import { httpsCallable } from 'firebase/functions';
import './BillingWidget.css';

const BillingWidget = () => {
    const [billingData, setBillingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBilling = async () => {
        setLoading(true);
        setError(null);
        try {
            const getBillingSummary = httpsCallable(functions, 'getBillingSummary');
            const result = await getBillingSummary();
            setBillingData(result.data);
        } catch (err) {
            console.error('Error fetching billing data:', err);
            setError(err.message || 'Failed to load billing data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBilling();
    }, []);

    if (loading) {
        return (
            <div className="billing-widget card-glass loading">
                <div className="stat-icon">💰</div>
                <div className="stat-info">
                    <h3>Current Month Expenses</h3>
                    <div className="loading-spinner small"></div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="billing-widget card-glass error" onClick={fetchBilling} style={{ cursor: 'pointer' }}>
                <div className="stat-icon">⚠️</div>
                <div className="stat-info">
                    <h3>Billing Error</h3>
                    <div className="stat-subtext">{error}</div>
                    <span className="retry-text">Click to retry</span>
                </div>
            </div>
        );
    }

    const { unadjustedCost, totalCost, totalCredits, currency, status, message, asOf, lastUsageTime } = billingData || {};

    const formatPrice = (val) => {
        return new Intl.NumberFormat('en-US', { 
            style: 'currency', 
            currency: currency || 'USD' 
        }).format(val || 0);
    };

    return (
        <div className="billing-widget card-glass">
            <span className="stat-icon">💰</span>
            <div className="stat-info">
                <h3>Current Month Expenses</h3>
                <div className="stat-value" title="Gross cost before credits">
                    {unadjustedCost !== undefined ? formatPrice(unadjustedCost) : '--'}
                </div>
                <div className="stat-subtext">
                    {status === 'pending' ? (
                        <span className="status-pending">{message || 'Export pending...'}</span>
                    ) : (
                        <div className="billing-details">
                            {totalCredits > 0 && (
                                <div className="savings-row">
                                    <span className="savings-label">Savings:</span> 
                                    <span className="savings-value">-{formatPrice(totalCredits)}</span>
                                </div>
                            ) || (
                                <div className="net-row">
                                    <span className="net-label">Net cost:</span>
                                    <span className="net-value">{formatPrice(totalCost)}</span>
                                </div>
                            )}
                            {lastUsageTime && (
                                <div className="timestamp-row">
                                    Data as of {new Date(lastUsageTime).toLocaleDateString()} {new Date(lastUsageTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <a 
                href="https://console.cloud.google.com/billing" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="external-link-icon"
                title="Open Cloud Billing Console"
            >
                ↗️
            </a>
        </div>
    );
};

export default BillingWidget;
